import { ComponentsTypes } from '@/constants/componentsTypes';
import { CoverageField } from '@/schemas/sceneDataSchema';
import CoverageCheckboxFormElement from './formElements/checkboxes/CoverageCheckboxFormElement';
import { CoverageChipFormElement } from './formElements/selects/CoverageChipFormElement';
import { CoverageSelectDropdownFormElement } from './formElements/selects/CoverageSelectDropdownFormElement';

export function DynamicCoverageFieldRenderer({ component }: { component: CoverageField }) {
  const renderElement = () => {
    switch (component.type) {
      case ComponentsTypes.COVERAGE_CHECKBOX:
        return <CoverageCheckboxFormElement component={component} />;
      case ComponentsTypes.COVERAGE_CHIP_GROUP:
        return <CoverageChipFormElement component={component} />;
      case ComponentsTypes.COVERAGE_SELECT_DROPDOWN:
        return <CoverageSelectDropdownFormElement component={component} />;
      default:
        return <>Component is not found</>;
    }
  };

  return renderElement();
}
